/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const getElevenlabsUsageDailyV1QuerySchema = z.object({
  days: z.coerce.number().int().min(1).max(90).default(30),
});

export type IGetElevenlabsUsageDailyV1Query = z.input<typeof getElevenlabsUsageDailyV1QuerySchema>;
